import { render, staticRenderFns } from "./CreateTest.vue?vue&type=template&id=36707a1d&scoped=true&"
import script from "./CreateTest.vue?vue&type=script&lang=js&"
export * from "./CreateTest.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./CreateTest.vue?vue&type=style&index=0&id=36707a1d&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "36707a1d",
  null
  ,true
)

export default component.exports